document.addEventListener("DOMContentLoaded", function () {
  initMobileNav();
  initReveal();
  initTrustPath();
  initLangToggle();
  initQtySteppers();
  initAddToCartToast();
  initNavDropdown();
});

function initNavDropdown() {
  const dropdown = document.getElementById("shopDropdown");
  if (!dropdown) return;
  const trigger = dropdown.querySelector(".nav-dropdown-trigger");
  trigger.addEventListener("click", function (e) {
    if (window.innerWidth <= 960) {
      e.preventDefault();
      const isOpen = dropdown.classList.toggle("open");
      trigger.setAttribute("aria-expanded", isOpen);
    }
  });
}

function initMobileNav() {
  const toggle = document.getElementById("navToggle");
  const links = document.getElementById("navLinks");
  if (!toggle || !links) return;
  toggle.addEventListener("click", function () {
    links.classList.toggle("open");
  });
}

function initReveal() {
  const items = document.querySelectorAll(".reveal");
  if (!items.length) return;
  if (!("IntersectionObserver" in window)) {
    items.forEach((i) => i.classList.add("in"));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  items.forEach((i) => io.observe(i));
}

function initTrustPath() {
  const path = document.querySelector(".trust-path");
  if (!path) return;
  const fill = path.querySelector(".trust-path-fill");
  const walker = path.querySelector(".trust-cat-walker");
  function update() {
    const rect = path.getBoundingClientRect();
    const vh = window.innerHeight;
    let progress = (vh * 0.8 - rect.top) / (rect.height + vh * 0.6);
    progress = Math.max(0, Math.min(1, progress));
    const pct = (progress * 100).toFixed(1) + "%";
    fill.style.setProperty("--fill", pct);
    walker.style.setProperty("--fill", pct);
  }
  window.addEventListener("scroll", update, { passive: true });
  update();
}

function applyLangText(lang) {
  document.querySelectorAll("[data-en]").forEach(function (el) {
    var text = lang === "ar" ? (el.getAttribute("data-ar") || el.getAttribute("data-en")) : el.getAttribute("data-en");
    if (text) el.textContent = text;
  });
}

function initLangToggle() {
  var btn = document.getElementById("langToggle");
  if (!btn) return;
  var stored = localStorage.getItem("catsy_lang") || "en";
  if (stored === "ar") {
    document.documentElement.setAttribute("dir", "rtl");
  }
  applyLangText(stored);
  btn.addEventListener("click", function () {
    var isAr = document.documentElement.getAttribute("dir") === "rtl";
    var newLang = isAr ? "en" : "ar";
    document.documentElement.setAttribute("dir", isAr ? "ltr" : "rtl");
    localStorage.setItem("catsy_lang", newLang);
    applyLangText(newLang);
  });
}

function initQtySteppers() {
  document.querySelectorAll(".qtyMinus, .qtyPlus").forEach((btn) => {
    btn.addEventListener("click", function () {
      const input = this.parentElement.querySelector("input[type='number']");
      if (!input) return;
      let val = parseInt(input.value || "1", 10);
      val = this.classList.contains("qtyMinus") ? Math.max(1, val - 1) : val + 1;
      input.value = val;
    });
  });
}

function initAddToCartToast() {
  document.querySelectorAll("form[action*='/cart/add'], .quickadd-form").forEach((form) => {
    form.addEventListener("submit", function () {
      sessionStorage.setItem("catsy_show_toast", "1");
    });
  });
  if (sessionStorage.getItem("catsy_show_toast")) {
    sessionStorage.removeItem("catsy_show_toast");
    const toast = document.getElementById("cartToast");
    if (toast) {
      toast.innerHTML = "🐾 Added to your cart";
      toast.classList.add("cart-toast--show");
      setTimeout(() => toast.classList.remove("cart-toast--show"), 2200);
    }
  }
}
